module.exports = __webpack_public_path__ + "img/home.f928cd10.svg";